import type { FaireProductEntity } from "../../entity_types/product";

export const p_mrdc3wmdh2: FaireProductEntity = {
  token: "p_mrdc3wmdh2",
  type: "product",
  name: "Ruth 18K Gold Vintage Adjustable Cross Ring",
  brandToken: "b_3tzh9mjdm6",
  brandName: "Flânerie by MAIQ",
  imageUrl:
    "https://cdn.faire.com/fastly/eb5df30839378d83c974d773d2b9ada05e8927b645b33dba1c3ab8b559d2c252.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/22278630d902d5aef89fad597962d65aa588ecb6992923e024b1e9cf84591d04.jpeg",
    "https://cdn.faire.com/fastly/b13456d6c7ccff946ba2a3023af528cfaa98215436648d63394bdb3e0178e8b1.jpeg",
  ],
  priceDollars: 6.21,
  description:
    "18K Gold Vintage Adjustable Cross Ring\n18K Gold Plating\nBrass\nMeasurement (L x W inch): Adjustable\n \n- Nickel-free, Lead-safe",
  tags: [],
  msrpDollars: 19.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:18.459Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
